import { Router } from '@angular/router';
import { Localizations } from '../../core/translations/localizations.service';
import * as i0 from "@angular/core";
import * as i1 from "../../core/translations/localizations.service";
import * as i2 from "@angular/router";
var LocalizationsResolve = /** @class */ (function () {
    function LocalizationsResolve(localizations, router) {
        this.localizations = localizations;
        this.router = router;
    }
    LocalizationsResolve.prototype.resolve = function (route) {
        var _this = this;
        return this.localizations.all().toPromise().then(function (response) {
            return response.localizations;
        }, function () {
            _this.router.navigate(['/admin']);
            return false;
        });
    };
    LocalizationsResolve.ngInjectableDef = i0.defineInjectable({ factory: function LocalizationsResolve_Factory() { return new LocalizationsResolve(i0.inject(i1.Localizations), i0.inject(i2.Router)); }, token: LocalizationsResolve, providedIn: "root" });
    return LocalizationsResolve;
}());
export { LocalizationsResolve };
